import * as React from "react";
import "./buttonPrimary.scss";
import DropDownWrapper from "../../molecules/DropDownWrapper/DropDownWrapper";
import DropDownList from "../../molecules/DropDownList/DropDownList";
import "./buttonWithDropdown.scss";
import Loading from "../../../../components/ui/loading/Loading";
import classNames = require("classnames");

interface IProps {
	/**
	 * Button label text.
	 */
	label: string;
	/**
	 * Dropdown menu elements.
	 */
	dropdownItems: ButtonDropdownItem[];
	/**
	 * Variant of button (primary or secondary)
	 */
	buttonVariant?: ButtonVariant;
	/**
	 * Indicates if loading animation is rendered inside button.
	 */
	isLoading?: boolean;
	/**
	 * If true, arrow down is displayed next to button label.
	 */
	displayArrowDown?: boolean;
	/**
	 * Dropdown wrapper width.
	 */
	dropdownWidth?: number;
	/**
	 * Dropdown item click callback.
	 * @param {string} showActionId
	 */
	onDropdownItemClick: (itemId: string) => void;
}

export enum ButtonVariant {
	PRIMARY = "PRIMARY",
	SECONDARY = "SECONDARY"
}

interface IState {
	/**
	 * Indicates if dropdown menu is expanded.
	 */
	dropDownMenuVisible: boolean;
}

export default class ButtonWithDropdown extends React.Component<IProps, IState> {

	public static defaultProps: Partial<IProps> = {
		buttonVariant: ButtonVariant.SECONDARY,
		displayArrowDown: true,
		dropdownWidth: 210
	};

	constructor(props: IProps) {
		super(props);
		this.state = {dropDownMenuVisible: false};
	}

	render() {
		const classFromProps = classNames({
			"a-button-primary": this.props.buttonVariant === ButtonVariant.PRIMARY,
			"a-button-secondary": this.props.buttonVariant === ButtonVariant.SECONDARY,
			"burgundy": this.props.buttonVariant === ButtonVariant.PRIMARY,
		});

		return (
			<div className="a-button-with-dropdown_outer-container">
				<div className="a-button-with-dropdown_button-container">
					<button className={classFromProps}
							onClick={() => this.setState({dropDownMenuVisible: true})}
							disabled={this.props.isLoading}>
						<span>{this.props.label}</span>
						{this.props.displayArrowDown &&
						<i className={"fa fa-fw fa-caret-down a-button-with-dropdown_arrow-down"}/>}
					</button>
				</div>
				{this.state.dropDownMenuVisible &&
				<DropDownWrapper width={this.props.dropdownWidth}
								 onOutsideClick={() => this.setState({dropDownMenuVisible: false})}>
					<DropDownList items={this.props.dropdownItems}
								  onSelect={(item: ButtonDropdownItem) => this.setState({dropDownMenuVisible: false},
									  () => this.props.onDropdownItemClick(item.id))}
								  itemToId={(item: ButtonDropdownItem) => item.id}
								  itemToLabel={this.itemToLabel}
								  itemDisabled={(item: ButtonDropdownItem) => item.disabled}/>
				</DropDownWrapper>}
			</div>
		);
	}

	itemToLabel = (item: ButtonDropdownItem) => {
		return (
			<>
				{item.label}
				{item.isLoading && <Loading isLoading={item.isLoading}
											spinnerSize={15}/>
				}
			</>
		)
	}
}

export class ButtonDropdownItem {
	constructor(public readonly id: string,
		public readonly label: string,
		public readonly isLoading: boolean,
		public readonly disabled: boolean
	) {}
}
